import type { TenantView } from '../../services/tenants/tenants.service';

export type ToggleTenantImpact = {
  title: string;
  lines: string[];
};

export const INITIAL_EXPANDED_TENANT_ID: number | null = null;

export const INITIAL_TENANT_NAME = '';

export const getTenantsCountLabel = (tenants: TenantView[]): string =>
  `סה"כ ${tenants.length} חברות`;
